export default "__VITE_ASSET__C4Hd0xJk__"